import React, { useCallback, useRef, useState } from 'react'
import { ShareOnTwitter } from './ShareOnTwitter'
import { ShareOnReddit } from './ShareOnReddit'
import { ShareOnHackerNews } from './ShareOnHackerNews'
import { ShareOnLowEndTalk } from './ShareOnLowEndTalk'
import { getGradient } from '../../tutorialsBase'
import { ShareLink } from './ShareLink'
import { useOnClickOutside } from '../../../utils/useOnClickOutside'
import * as styles from './ShareSection.module.scss'

export const ShareSection = ({ frontmatter }) => {
  const ref = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const gradient = getGradient(frontmatter.header_img)

  const onOpen = () => setIsOpen(true)

  const onClickOutside = useCallback(() => {
    if (isOpen) {
      setIsOpen(false)
    }
  }, [isOpen])

  useOnClickOutside(ref, onClickOutside)

  return (
    <div
      className={`box-gradient ${ gradient.bigBox } ${ styles.wrapper }`}
      onClick={onOpen}
      onFocus={onOpen}
      onBlur={() => setIsOpen(false)}
      ref={ref}
      role={'button'}
    >
      <div className={`${styles.transitionWrapper} ${isOpen ? styles.open : ''}`}>
        <span className={`color-white ${styles.textWrapper}`}>
          <i className='fa fa-share-alt mr-2'/> Share
        </span>
        <div className={styles.buttonsWrapper} role={'menu'}>
          <ShareOnHackerNews frontmatter={ frontmatter } role={'menuitem'} />
          <ShareOnLowEndTalk frontmatter={ frontmatter } role={'menuitem'} />
          <ShareOnReddit frontmatter={ frontmatter } role={'menuitem'} />
          <ShareOnTwitter frontmatter={ frontmatter } role={'menuitem'} />
          <ShareLink role={'menuitem'} />
        </div>
      </div>
    </div>
  )
}
